import { observer } from 'mobx-react-lite';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import * as React from 'react';
const styles = require('./MessageAdListStubElement.scss');
const MessageAdListPreloadingStubElement = observer(
    function MessageAdListPreloadingStubElement(props: {}) {
        const readingPanePostion = getUserConfiguration().UserOptions
            .GlobalReadingPanePositionReact;
        const useAdViewOneLine =
            readingPanePostion === ReadingPanePosition.Off ||
            readingPanePostion === ReadingPanePosition.Bottom;

        return (
            <div
                className={
                    useAdViewOneLine
                        ? styles.messageAdStaticContainerOneLine
                        : styles.messageAdStaticContainerThreeLine
                }
            />
        );
    }
);
export default MessageAdListPreloadingStubElement;
